import { render, staticRenderFns } from "./UploadAssessment.vue?vue&type=template&id=1abd2aba&scoped=true"
import script from "./UploadAssessment.vue?vue&type=script&lang=js"
export * from "./UploadAssessment.vue?vue&type=script&lang=js"
import style0 from "./UploadAssessment.vue?vue&type=style&index=0&id=1abd2aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abd2aba",
  null
  
)

export default component.exports